export default "__VITE_ASSET__BGBPmpI8__"